@if (eligibilityTree) {
  @if (eligibilityTree.rootOperator !== null) {
    <eas-editor-eligibility-operator
      [operator]="eligibilityTree.rootOperator"
      [ruleList]="eligibilityTree.ruleList"
      [isLastSibling]="true"
      >
    </eas-editor-eligibility-operator>
  }
}

<ng-template #loading>
  <h1 i18n>Loading...</h1>
</ng-template>
